import { WizIcon } from './wiz-icon';
import { NgModule } from "@angular/core";
import { WizBehaviorDirectiveModule } from '../../../directives/behavior/wiz-behavior-directives.module';

@NgModule({
  declarations: [ WizIcon ],
  imports: [
    WizBehaviorDirectiveModule
    
  ],
  exports : [ WizIcon]
})
export class WizIconModule {

}
